import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import RightIcon from '@material-ui/icons/KeyboardArrowRight';
import { StyledDialog, StyledLink } from './InstructionsStyles';
import RuInstruction from '../../_assets/files/instruction_ru.pdf';
import KkInstruction from '../../_assets/files/instruction_kk.pdf';
import KkGettingDirectionsDDO from '../../_assets/files/KkGettingDirectionsDDO.pdf';
import RuGettingDirectionsDDO from '../../_assets/files/RuGettingDirectionsDDO.pdf';
import KkGuideServiceRecipients from '../../_assets/files/KkGuideServiceRecipients.pdf';
import RuGuideServiceRecipients from '../../_assets/files/RuGuideServiceRecipients.pdf';
import ReceiveVoucherKK from '../../_assets/files/ReceiveVoucherKK.pdf';
import ReceiveVoucherRU from '../../_assets/files/ReceiveVoucherRu.pdf';

import './InstructionsTranslate';

const instructions = [
  {
    ru: RuInstruction,
    kk: KkInstruction,
    ru_name:
      'Прием документов и зачисление в организации образования (начальные, осн. ср., общ.ср, спец.)',
    kk_name:
      'Білім беру ұйымдарына құжаттарды қабылдау және оқуға қабылдау (мектепке дейінгі, бастауыш, негізгі орта, жалпы орта, арнайы)'
  },
  {
    ru: RuGuideServiceRecipients,
    kk: KkGuideServiceRecipients,
    ru_name: 'Руководство для услугополучателей',
    kk_name: 'Қызмет алушыға арналған нұсқаулық'
  },
  {
    ru: RuGettingDirectionsDDO,
    kk: KkGettingDirectionsDDO,
    ru_name: 'Постановка на очередь ребенка для получения направления в ДДО',
    kk_name: 'МДҰ-ға жолдама алу үшін баланы кезекке қою'
  },
  {
    ru: ReceiveVoucherRU,
    kk: ReceiveVoucherKK,
    ru_name:
      'Руководство по постановке в очередь на получения ваучера и зачисления в ДДО',
    kk_name: 'Ваучер алу үшін кезекке тұру және МДҰ-ға тіркелу бойынша нұсқаулық'
  }
];

function Instructions() {
  const { t, i18n } = useTranslation();
  const [selected, setSelected] = useState(null);

  return (
    <div className="mb3 mt3 fullWidth">
      <Typography children={t('instructions_title')} color="secondary" variant="h6" />
      <div className="mb3" />
      {instructions.map((item, key) => (
        <Card
          key={key}
          className="my1 p2 pointer flex items-center"
          variant="outlined"
          onClick={() => setSelected(item)}
        >
          <RightIcon color="action" className="mr2" />
          <StyledLink>{item[`${i18n.language}_name`]}</StyledLink>
        </Card>
      ))}
      {selected && (
        <StyledDialog open={true} onClose={() => setSelected(null)} maxWidth="xl">
          <div className="p2 bold center">{selected[`${i18n.language}_name`]}</div>
          <object
            width="100%"
            data={selected[i18n.language]}
            style={{ height: '100vh' }}
          ></object>
        </StyledDialog>
      )}
    </div>
  );
}

export default Instructions;
